import $ from 'jquery'
import { generateProductHTML, setSameHeight } from '../abstracts/utils'

export default () => {
  $(() => {
    if (!$('body').hasClass('page-template-price-tags')) return

    setSameHeight($('.section-price-tags .products .product .product__content'))
    $(window).on('resize', function() {
      setSameHeight($('.section-price-tags .products .product .product__content'))
    })

    $('.section-price-tags .load-more-cta a').click(e => {
      e.preventDefault()
      const target = $(e.target)
      let nextPage = parseInt(target.attr('current-page')) + 1
      const rootProductCat = target.attr('root-product-cat')
      $.get(window.endpoint + '/get-products-by-cat', {
        'page': nextPage,
        'root_product_cat': rootProductCat
      })
        .done(res => {
          for (let i = 0; i < res.products.length; i++) {
            $('.section-price-tags .products').append(generateProductHTML(res.products[i]))
          }
          $(e.target).attr('current-page', nextPage)
          if (nextPage >= res.max_num_pages)
            $(e.target).parent().addClass('hide')

          setSameHeight($('.section-price-tags .products .product .product__content'))
        })
        .fail(err => {
          console.log(err)
        })
    })
  })
}
